module.exports = __webpack_public_path__ + "img/t1-purple.67b049a4.png";